// src/components/dashboard/Dashboard.jsx
import { useState, useEffect } from 'react';
import { database } from '../../config/firebase';
import { ref, onValue, remove, update } from 'firebase/database';
import Header from './Header';
import Footer from './Footer';
import StudentTable from './StudentTable';
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const Dashboard = () => {
  const [students, setStudents] = useState([]);
  const [ip, setIp] = useState('');

  useEffect(() => {
    const studentsRef = ref(database, 'students');
    const unsubscribe = onValue(studentsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const studentsArray = Object.entries(data).map(([id, values]) => ({
          id,
          ...values,
        }));
        setStudents(studentsArray);
      }
    });

    // Get user IP address
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => setIp(data.ip))
      .catch(() => setIp('Unknown'));

    return () => unsubscribe();
  }, []);

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    
    // Add header
    doc.setFontSize(18);
    doc.text('Student Registration List', 15, 15);
    
    // Add table
    doc.autoTable({
      startY: 25,
      head: [['Name', 'Mobile', 'WhatsApp', 'Email', 'Address', 'Country']],
      body: students.map(student => [
        student.name,
        student.mobileNumber,
        student.whatsappNumber,
        student.email,
        student.address,
        student.country
      ]),
      styles: { fontSize: 9 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255 },
      alternateRowStyles: { fillColor: [245, 245, 245] }
    });

    doc.save('students-list.pdf');
  };

  const handleEdit = async (id, data) => {
    try {
      await update(ref(database, `students/${id}`), data);
      Swal.fire('Success', 'Student updated successfully', 'success');
    } catch (error) {
      Swal.fire('Error', error.message, 'error');
    }
  };

  const handleDelete = async (id) => {
    try {
      await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          await remove(ref(database, `students/${id}`));
          Swal.fire('Deleted!', 'Student has been deleted.', 'success');
        }
      });
    } catch (error) {
      Swal.fire('Error', error.message, 'error');
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header onDownload={handleDownloadPDF} />
      <main className="flex-grow p-6 max-w-7xl mx-auto w-full">
        <div className="bg-white rounded-lg shadow-sm border">
          <StudentTable
            students={students}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        </div>
      </main>
      <Footer ip={ip} />
    </div>
  );
};

export default Dashboard;